import { render, staticRenderFns } from "./BottomMobile.vue?vue&type=template&id=43141fe5&scoped=true&"
import script from "./BottomMobile.vue?vue&type=script&lang=js&"
export * from "./BottomMobile.vue?vue&type=script&lang=js&"
import style0 from "./BottomMobile.vue?vue&type=style&index=0&id=43141fe5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43141fe5",
  null
  
)

export default component.exports